const initialState = {
    dashboardDataList: null,
    isFetchingDashboardData: false,
    lastFetched: null,
};

const AccountsDashboardReducer = (state = initialState, action) => {
    switch (action.type) {

        case "REQUEST_DASHBOARD_DATA":
            return { ...state, isFetchingDashboardData: true };
        case "SUCCESS_DASHBOARD_DATA":
            return { ...state, dashboardDataList: action.payload, isFetchingDashboardData: false, lastFetched: Date.now() };
        case "ERROR_DASHBOARD_DATA":
            return { ...state, isFetchingDashboardData: false, dashboardDataList: state.dashboardDataList || {} };


        default:
            return state;
    }
};

export default AccountsDashboardReducer;